import { Platform } from "@uniswap/client-data-api/dist/data/v1/api_pb";
import { ProtocolVersion } from "@uniswap/client-pools/dist/pools/v1/types_pb";
import {
  ProtectionAttackType,
  ProtectionResult,
  SafetyLevel
} from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { logger } from "utilities/src/logger/logger";
export function parseSafetyLevel(safetyLevel) {
  if (!safetyLevel) {
    return void 0;
  }
  const validSafetyLevels = Object.values(SafetyLevel);
  if (validSafetyLevels.includes(safetyLevel)) {
    return safetyLevel;
  } else {
    logger.warn(
      "uniswap/data/rest/utils.ts",
      "parseSafetyLevel",
      `Invalid safetyLevel from REST TokenRankings query: ${safetyLevel}`
    );
    return void 0;
  }
}
export function parseProtectionInfo(protectionInfo) {
  if (!protectionInfo) {
    return void 0;
  }
  let protectionResult;
  const validProtectionResults = Object.values(ProtectionResult);
  if (validProtectionResults.includes(protectionInfo.result.toUpperCase())) {
    protectionResult = protectionInfo.result.toUpperCase();
  } else {
    logger.warn(
      "uniswap/data/rest/utils.ts",
      "parseProtectionInfo",
      `Invalid protectionResult from REST TokenRankings query: ${protectionInfo.result}`
    );
    return void 0;
  }
  const validAttackTypes = Object.values(ProtectionAttackType);
  const attackTypes = protectionInfo.attackTypes.filter((at) => validAttackTypes.includes(at.toUpperCase())).map((at) => at.toUpperCase());
  if (attackTypes.length !== protectionInfo.attackTypes.length) {
    logger.warn(
      "uniswap/data/rest/utils.ts",
      "parseProtectionInfo",
      `Invalid attackTypes in REST TokenRankings query: ${protectionInfo.attackTypes}`
    );
  }
  return { attackTypes, result: protectionResult };
}
export function parseRestProtocolVersion(version) {
  switch (version?.toLowerCase()) {
    case "v2":
      return ProtocolVersion.V2;
    case "v3":
      return ProtocolVersion.V3;
    case "v4":
      return ProtocolVersion.V4;
    default:
      return void 0;
  }
}
export function createWalletAccount({ evmAddress, svmAddress }) {
  const platformAddresses = [];
  if (evmAddress) {
    platformAddresses.push({ platform: Platform.EVM, address: evmAddress });
  }
  if (svmAddress) {
    platformAddresses.push({ platform: Platform.SVM, address: svmAddress });
  }
  return {
    walletAccount: {
      platformAddresses
    }
  };
}
export function transformInput(input) {
  if (!input) {
    return void 0;
  }
  const {
    evmAddress,
    svmAddress,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    walletAccount: _walletAccount,
    ...restInput
  } = input;
  return {
    ...createWalletAccount({ evmAddress, svmAddress }),
    ...restInput
  };
}
